import { render, staticRenderFns } from "./courseListWtxh.vue?vue&type=template&id=afda0b18&scoped=true"
import script from "./courseListWtxh.vue?vue&type=script&lang=js"
export * from "./courseListWtxh.vue?vue&type=script&lang=js"
import style0 from "./courseListWtxh.vue?vue&type=style&index=0&id=afda0b18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afda0b18",
  null
  
)

export default component.exports